import { Component, input } from '@angular/core';

@Component({
  selector: 'app-ui-section-header',
  imports: [],
  template: `
    <div class="m-section">
      <h2 class="m-section__title">{{ title() }}</h2>
      @if (description()) {
      <p class="m-section__description">{{ description() }}</p>
      }
    </div>
  `,
  styleUrl: './ui-section-header.component.scss',
})
export class UiSectionHeaderComponent {
  title = input.required<string>();
  description = input<string>();
}
